import { Direction } from 'interfaces/interface-studio-canvas';
import Moveable, { MoveableTargetGroupsType } from 'react-moveable';
import { create } from 'zustand';

interface UseMoveableStoreInterface {
  moveableRef: React.MutableRefObject<Moveable<{}> | null> | null;
  setMoveableRef: (ref: React.MutableRefObject<Moveable<{}> | null>) => void;

  updateMoveableRect: () => void; // Update the rect of the moveable instance for a specific block

  targets: MoveableTargetGroupsType;
  setTargets: (targets: MoveableTargetGroupsType) => void;

  renderDirections: Direction[];
  handleRenderDirection: (tag: string) => void;
  setRenderDirections: (directions: Direction[]) => void;
  rotatable: boolean;
  setRotateable: (value: boolean) => void;
}

export const useMoveableStore = create<UseMoveableStoreInterface>()(
  (set, get) => {
    return {
      moveableRef: null,
      targets: [],
      renderDirections: ['n', 's', 'e', 'w', 'nw', 'ne', 'sw', 'se'],
      rotatable: true,

      setMoveableRef: (ref) => set({ moveableRef: ref }),

      updateMoveableRect: () => {
        const moveableRef = get().moveableRef;
        if (
          moveableRef &&
          typeof moveableRef?.current?.updateRect === 'function'
        ) {
          moveableRef.current.updateRect();
        }
      },
      setTargets: (targets) => {
        set({ targets });
      },
      setRenderDirections: (renderDirections) => {
        set({ renderDirections });
      },
      handleRenderDirection: (tag) =>
        set(() => {
          if (tag === 'rect' || tag === 'path' || tag === 'line') {
            return {
              renderDirections: [],
            };
          } else if (tag === 'shape') {
            return { renderDirections: ['n', 's', 'e', 'w'] };
          } else if (tag === 'image') {
            return {
              renderDirections: ['n', 's', 'e', 'w', 'nw', 'ne', 'sw', 'se'],
            };
          } else {
            return {
              renderDirections: [],
            };
          }
        }),
      setRotateable: (value) => set({ rotatable: value }),
    };
  }
);
